import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg width="18" height="18" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
    <g clipPath="url(#clip0)">
      <path d="M35 24C37.7614 24 40 21.7614 40 19C40 16.2385 37.7614 14 35 14C32.2386 14 30 16.2385 30 19C30 21.7614 32.2386 24 35 24Z" stroke="#B5B4B8" strokeWidth="4.5" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M19.0001 12C21.7615 12 24.0001 9.76139 24.0001 6.99997C24.0001 4.23855 21.7615 1.99997 19.0001 1.99997C16.2386 1.99997 14.0001 4.23855 14.0001 6.99997C14.0001 9.76139 16.2386 12 19.0001 12Z" stroke="#B5B4B8" strokeWidth="4.5" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M26.9521 32H38.0001C43.6341 32 44.0001 36 44.0001 36L20.4701 45.05C18.8961 45.656 17.1401 45.57 15.6321 44.816L2.00006 38V24H4.00006C6.21006 24 11.8121 24.876 14.0001 28H20.0001C24.4181 28 28.0001 31.582 28.0001 36H14.0001" stroke="#B5B4B8" strokeWidth="4.5" strokeMiterlimit="10" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
};

export default SVG;
